<template>
  <TgSlidePanel :open="showFormPanel" :on-close="closeFormPanel" side="left" width="max-w-5xl" :overlay="true" z="z-40">
    <template #title>
      FR-{{ item.id }}
    </template>
    <template #subtitle>
      Flight report form
    </template>
    <template #content>
      <form-panel
        ref="FormPanel" :slug="slug" :tab="tab" :selected="item" @formerror="formHasError"
        @formsuccess="receiveFormData"
      />
    </template>
    <template #footer>
      <TgSubmit :disabled="submitting" @click="submitForm">
        Update
      </TgSubmit>
    </template>
  </TgSlidePanel>

  <div v-if="item" class="el_1_f08d9a633a0e7d7808a0f51038aa8648 bg-gray-100 rounded-md">
    <div
      class="el_2_f08d9a633a0e7d7808a0f51038aa8648 p-3 uppercase rounded-t-md"
      :class="status_colors[item.status_colors]"
    >
      <div class="el_3_f08d9a633a0e7d7808a0f51038aa8648 flex items-center text-white">
        <div class="el_4_f08d9a633a0e7d7808a0f51038aa8648 flex-1 text-lg">
          Flight report #{{ item.id }} -
          <span class="el_5_f08d9a633a0e7d7808a0f51038aa8648 text-base">({{ item.hoursremaining }} Hours Remain)</span>
        </div>
        <div class="el_6_f08d9a633a0e7d7808a0f51038aa8648 flex-shrink-0 text-right">
          <TgBadge v-if="tab.access == 'Full'" color="dark" class="cursor-pointer" @click="openForm()">
            Edit
          </TgBadge>
        </div>
      </div>
    </div>
    <div class="el_7_f08d9a633a0e7d7808a0f51038aa8648 flex flex-col px-4 py-4 space-y-2">
      <div class="el_8_f08d9a633a0e7d7808a0f51038aa8648 flex-1 space-y-2">
        <div class="el_9_f08d9a633a0e7d7808a0f51038aa8648 flex items-center">
          <!-- <div class="el_10_f08d9a633a0e7d7808a0f51038aa8648 w-1/4">
            <div class="el_11_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              Section
            </div>
            <div class="el_12_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 whitespace-normal">
              {{ item.section }}
            </div>
          </div> -->
          <div class="el_13_f08d9a633a0e7d7808a0f51038aa8648 w-1/3">
            <div class="el_14_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              category
            </div>
            <div class="el_15_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.category }}
            </div>
          </div>
          <div class="el_16_f08d9a633a0e7d7808a0f51038aa8648 w-1/3">
            <div class="el_17_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              subcategory
            </div>
            <div class="el_18_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.subcategory }}
            </div>
          </div>
          <div class="el_19_f08d9a633a0e7d7808a0f51038aa8648 w-1/3">
            <div class="el_20_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              cabin class
            </div>
            <div class="el_21_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.cabinclass }}
            </div>
          </div>
        </div>
        <div class="el_22_f08d9a633a0e7d7808a0f51038aa8648 flex items-center">
          <div class="el_23_f08d9a633a0e7d7808a0f51038aa8648 w-1/3">
            <div class="el_24_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              Derived Caterer
            </div>
            <div class="el_25_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.caterer }}
            </div>
          </div>
          <div class="el_26_f08d9a633a0e7d7808a0f51038aa8648 w-1/3">
            <div class="el_27_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              Derived Port
            </div>
            <div class="el_28_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.departureport }}
            </div>
          </div>
          <div class="el_29_f08d9a633a0e7d7808a0f51038aa8648 w-1/3">
            <div class="el_30_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              Service Port
            </div>
            <div class="el_31_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.targetport }}
            </div>
          </div>
        </div>
        <div class="el_35_f08d9a633a0e7d7808a0f51038aa8648 flex items-center">
          <div class="el_32_f08d9a633a0e7d7808a0f51038aa8648 w-1/3">
            <div class="el_33_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              Hours Remaining
            </div>
            <div class="el_34_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.hoursremaining }}
            </div>
          </div>
          <div class="el_36_f08d9a633a0e7d7808a0f51038aa8648 w-1/3">
            <div class="el_37_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              OTP Minutes
            </div>
            <div class="el_38_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.minutes || "N/A" }}
            </div>
          </div>

          <!-- <div class="el_39_f08d9a633a0e7d7808a0f51038aa8648 w-2/4">
            <div class="el_40_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
              MSC Flight
            </div>
            <div class="el_41_f08d9a633a0e7d7808a0f51038aa8648 text-gray-600 truncate">
              {{ item.mscflag || "N/A" }}
            </div>
          </div> -->
        </div>
      </div>
      <div class="el_42_f08d9a633a0e7d7808a0f51038aa8648 flex-col space-y-3">
        <div class="el_43_f08d9a633a0e7d7808a0f51038aa8648 flex-1">
          <div class="el_44_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
            Crew Comment
          </div>
          <div
            class="el_45_f08d9a633a0e7d7808a0f51038aa8648 text-base text-gray-600 whitespace-pre-line bg-gray-200 p-2 mt-2 rounded-md"
          >
            {{ item.comments }}
          </div>
        </div>
        <div class="el_46_f08d9a633a0e7d7808a0f51038aa8648 flex-1">
          <div class="el_47_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase flex justify-between">
            <div>Caterer Response</div>
            <TgBadge v-if="item.status_caterer_id == 2026" :color="'danger'">
              Declined
            </TgBadge>
            <TgBadge v-if="item.status_caterer_id == 2025" :color="'success'">
              Accepted
            </TgBadge>
          </div>
          <div
            class="el_48_f08d9a633a0e7d7808a0f51038aa8648 text-base text-gray-600 whitespace-normal bg-white p-2 mt-2 rounded-md"
          >
            {{ item.catererresponse }}
            <div v-if="item.caterer_response_by" class="text-sm text-gray-400 pt-2">
              By: {{ item.caterer_response_by }} - {{ item.catererresponsets }}
            </div>
          </div>
        </div>
        <div class="el_49_f08d9a633a0e7d7808a0f51038aa8648 flex-1">
          <div class="el_50_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase flex justify-between">
            <div>Airline Response</div>
            <TgBadge v-if="item.status_airline_id == 2026" :color="'danger'">
              Disagree
            </TgBadge>
            <TgBadge v-if="item.status_airline_id == 2025" :color="'success'">
              Agree
            </TgBadge>
          </div>
          <div
            class="el_51_f08d9a633a0e7d7808a0f51038aa8648 text-base text-gray-600 whitespace-normal bg-white p-2 mt-2 rounded-md"
          >
            {{ item.airlineresponse }}
            <div v-if="item.airline_response_by" class="text-sm text-gray-400 pt-2">
              By: {{ item.airline_response_by }} - {{ item.airlineresponsets }}
            </div>
          </div>
        </div>
        <div v-if="item.imagename" class="el_52_f08d9a633a0e7d7808a0f51038aa8648 flex-1">
          <div class="el_53_f08d9a633a0e7d7808a0f51038aa8648 mb-2 text-gray-400 uppercase">
            Photo
          </div>
          <tg-image :path="item.imagename" :thumb="true" class="shadow-md" />
        </div>
        <div v-if="attachments.length > 0" class="text-gray-400 uppercase pt-2">
          Attachments
        </div>
        <div class="flex space-x-2">
          <div v-for="(attachment, file_idx) in attachments" :key="file_idx" class="flex-shrink-0 px-3">
            <div class="text-center group flex flex-col hover:cursor-pointer">
              <div class="h-16" @click="get_secure_download_url(attachment.secure_url)">
                <svg
                  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-16 h-16 mx-auto"
                >
                  <path
                    stroke-linecap="round" stroke-linejoin="round"
                    d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                  />
                </svg>
              </div>
              <a class="text-center text-sm cursor-pointer" @click="get_secure_download_url(attachment.secure_url)">{{
                getFilenameFromLink(attachment.secure_url) }}</a>
              <span
                class="text-red-400 text-xs invisible hover:underline cursor-pointer group-hover:visible"
                @click="remove_attachement(file_idx)"
              >Remove</span>
            </div>
          </div>
        </div>
        <div v-if="item._canedit == 1">
          <!-- <TgCloudinaryUploader :folder="`performance/${item.id}/${guid}`" @upload:success="afterUpload" /> -->
          <div class="flex flex-col items-center cursor-pointer" @click="triggerFilePickerAndReset">
            <svg
              xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="w-12 h-12 text-gray-400"
            >
              <path
                stroke-linecap="round" stroke-linejoin="round"
                d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
              />
            </svg>
            <div class="mt-2 text-gray-600">
              Attach File
            </div>
          </div>

          <!-- Hidden File Input for Uploader -->
          <input
            id="file-upload" ref="fileRef" type="file" multiple accept=".pdf,.jpg,.jpeg,.png" class="hidden"
            @change="onChange"
          >
        </div>
        <div class="el_54_f08d9a633a0e7d7808a0f51038aa8648 flex-1 mt-3 text-center">
          <div class="el_55_f08d9a633a0e7d7808a0f51038aa8648 text-gray-400 uppercase">
            Overall Status
          </div>
          <div class="el_56_f08d9a633a0e7d7808a0f51038aa8648 text-2xl text-gray-600 whitespace-normal">
            <TgBadge :color="item.status_css">
              {{ item.status }}
            </TgBadge>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TgSlidePanel from "@/components/Common/TgSlidePanel.vue";
import { API } from "@/api";
import { UTILS } from "@/utils";
import { STATUS_COLORS } from "@/default";
import TgBadge from "@/components/Common/TgBadge";
import TgSubmit from "@/components/Common/TgSubmit";
import TgImage from "@/components/Common/TgImage";
import dayjs from "dayjs";

import _has from "lodash/has";
import _get from "lodash/get";
import _each from "lodash/each";
import FormPanel from "@/components/Grids/FormPanel.vue";

export default {
  components: {
    TgSlidePanel,
    TgSubmit,
    FormPanel,
    TgBadge,
    TgImage,
  },
  props: {
    item: Object,
    config: Object,
    tab: Object,
    refreshlist: Function,
  },
  emits: ["on:update", "on:refresh"],
  data() {
    return {
      emitter: API.get_emitter(),
      attachments: JSON.parse(_get(this.item, "attachments", "[]")),
      colors: STATUS_COLORS,
      guid: UTILS.guid(),
      categories: null,
      open: false,
      submitting: false,
      showFormPanel: false,
      slug: null,
      status_colors: {
        red: "bg-red-400 text-white",
        yellow: "bg-yellow-400 text-white",
        blue: "bg-primary-400 text-white",
        green: "bg-green-400 text-white",
        gray: "bg-gray-400 text-white",
      },
    };
  },

  methods: {
    getFilenameFromLink(link) {
      const url = new URL(link);
      const pathParts = url.pathname.split("/");
      return pathParts[pathParts.length - 1];
    },
    async get_secure_download_url(link) {
      this.sending = true;

      this.status = "Getting secure download location...";

      let resp = await API.get_secure_download_url(link)

      if (resp) {
        this.sending = false;
        let url = resp.data.data;
        let win = window.open(url, "_blank");
        win.focus();
      }
    },
    async get_secure_upload_url(file) {

      let today = dayjs().format("YYYY/MM/DD");

      const params = {
        action: "put",
        folder: `TTL=99-Years/worker=service-reports/${today}/${this.item.id}`,
        filekey: `TTL=99-Years/worker=service-reports/${today}/${this.item.id}/${file.name}`,
        pub: 0,
        filetype: file.type,
      };

      try {
        const resp = await API.get_secure_upload_url(this.slug, file.name, params);
        const { filename, key, link, url } = resp.data.data;

        await this.upload(file, url);

        // Use the link provided by API if available, fallback to known path
        return { link: link };
      } catch (err) {
        console.error("Error getting secure upload URL:", err);
        throw err;
      }
    },
    async upload(file, signedUrl) {
      try {
        await fetch(signedUrl, {
          method: "PUT",
          body: file,
          headers: {
            "Content-Type": file.type,
          },
        });
      } catch (err) {
        console.error("Error uploading file:", err);
        throw err;
      }
    },
    async onChange(event) {
      const files = event.target.files;
      if (files.length > 0) {
        try {
          const uploadPromises = Array.from(files).map((file) => this.get_secure_upload_url(file));
          const uploadedFiles = await Promise.all(uploadPromises);
          this.afterUpload(uploadedFiles);
        } catch (error) {
          console.error("Upload error:", error);
          // Optionally notify the user here
        }
      }
    },
    async afterUpload(files) {

      let attachments = JSON.parse(JSON.stringify(this.attachments));
      _each(files, (file) => {
        attachments.push({
          secure_url: file.link
        });
      });
      let id = this.item._hashid || this.item.id;
      await API.update("84D444B71CE4441CADED9890820B3805", id, {
        attachments: JSON.stringify(attachments),
      });
      this.$emit("on:refresh");
    },
    async remove_attachement(idx) {

      let result = await this.$swal.fire({
        title: "Please confirm",
        text: `You are about to delete this attachment. Are you sure?`,
        showCancelButton: true,
        confirmButtonText: "Yes",
      });

      if (!result.isConfirmed) return;

      this.attachments.splice(idx, 1);
      let id = this.item._hashid || this.item.id;
      await API.update("84D444B71CE4441CADED9890820B3805", id, {
        attachments: JSON.stringify(this.attachments),
      });
      this.$notify({
        group: "toast",
        type: "success",
        title: "Success",
        text: "Attachment removed.",
      });
    },
    triggerFilePickerAndReset() {
      // Reset the file input and trigger click
      this.$refs.fileRef.value = "";
      this.$refs.fileRef.click();
    },
    openForm() {
      let slug = this.config.formslug;

      if (_has(this.config, "supplier")) {
        if (this.item._canedit == 0) {
          this.$notify({
            group: "toast",
            type: "danger",
            title: "Edit Denied",
            text: "This report has been closed. No changes can be made.",
          });
          return;
        }
      }
      this.slug = slug;
      this.openFormPanel();
    },
    openFormPanel() {
      this.showFormPanel = true;
    },
    formHasError() {
      this.submitting = false;
    },
    async receiveFormData(data) {
      this.submitting = false;
      this.emitter.emit("crew-report-updated");
      this.refreshlist();
      this.closeFormPanel();
    },
    submitForm() {
      this.submitting = true;
      this.$refs.FormPanel.submit();
    },
    closeFormPanel() {
      this.showFormPanel = false;
    },
  },
};
</script>